import { useSWR, useSWRMutation } from '@tiger/swr';
import { BankCardItemTypes } from 'components/BankCardSelect';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { QueryType, WayType } from './types';

/**
 * 获取银行卡列表
 * 因存在新增、编辑、删除银行卡的操作，后会返回到银行卡列表页面，这里不能走缓存数据
 * 因此使用useSWR时，卸载的时候清除缓存，降低额外的操作引起的心智负担
 */
export function useGetBankCards(params: { queryType: QueryType; way?: WayType; country?: string }) {
    return useSWRMutation(`get.bank.cards.${JSON.stringify(params)}`, () =>
        http
            .get<BankCardItemTypes[]>(API.TRADE.bankcards.getBankCards(), {
                params: {
                    ...params,
                    accountId: security.currentAccountId,
                    customerId: security.currentCustomerId
                }
            })
            .then(({ data }) => data)
    );
}

// 获取某一个银行卡
export function useGetBankCardItem(id: string) {
    return useSWR(
        {
            url: id && API.TRADE.bankcards.getBankCardItem(id),
            params: {
                accountId: security.currentAccountId,
                customerId: security.currentCustomerId
            }
        },
        {
            dataChain: ({ data }) => data
        }
    );
}

export function useDeleteBankCard() {
    return useSWRMutation('delete.bank.card', (id: number | string) =>
        http.post(API.TRADE.bankcards.deleteBankCardItem(id), {
            params: {
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId
            }
        })
    );
}
